<template>
    <div id="signin_wrapper" :style="backgroundImage">
        <v-snackbar :timeout="alertDuration" v-model="alertDialog" absolute centered top elevation="20" :color="alertColor"
            class="pa-6 pt-0 mt-12 top_level">
            <div class="text-center title font-weight-medium"
                :class="alertColor == 'success' ? 'grow--text' : 'white--text'" v-html="alertMessage">
            </div>
        </v-snackbar>

        <v-container fluid style="height: 100%; padding: 0 0 0 0">
            <v-row style="height: 100%;">
                <v-col id="signin_form" cols="5 pl-15 pt-15">
                    <v-row>
                        <div class="pl-6">
                            <a class="return_link sansation white--text text--darken-2"
                                href="https://www.successionresource.com" target="_blank">
                                <v-img :src="logo_img" width="206" class="ma-0 mb-1 ml-n2"
                                    atl="Succession Resource Group"></v-img>
                            </a>
                        </div>
                        <div class="pl-6">
                            <h1 class="sansation_subtitle white--text mycompass_title">myCompass</h1>
                            <p class="sansation_subtitle white--text">Exclusive client portal for SRG members to manage
                                project progress, access benchmarking data and explore our seller marketplace.</p>
                        </div>
                    </v-row>
                    <div id="login">
                        <v-form ref="auth_form" 
                            v-model="auth_valid" 
                            v-if="showAccessCodeForm">
                            
                            <div class="text-left">
                                <h3 class="sansation_subtitle white--text">Check your email for a code</h3>
                                <p class="sansation white--text">We've sent a 6-character code to your email address. The
                                    code expires shortly, so please enter it soon.</p>
                            </div>

                            <div class="d-block sansation_title text-left white--text">Access Code</div>
                            <div class="d-block">
                                <v-text-field v-model="accessCode" solo background-color="grey lighten-4"
                                    :rules="accessCodeRules" required ref="mfa_field">
                                    <template v-slot:prepend-inner>
                                        <v-icon color="teal">mdi-email-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </div>
                            <v-btn
                                class="sansation login_btn" 
                                style="height: 50px" 
                                color="teal lighten-5"
                                dark
                                @click.stop.prevent="mfa">
                                Submit
                            </v-btn>
                        </v-form>
                        
                        <v-form ref="login_form"
                            v-model="login_valid" 
                            v-if="!showAccessCodeForm">
                            
                            <div class="d-block sansation_title text-left white--text">Email</div>
                            <div class="d-block">
                                <v-text-field 
                                    v-model="username" 
                                    solo 
                                    background-color="grey lighten-4"
                                    :rules="emailRules" 
                                    required>
                                    <template v-slot:prepend-inner>
                                        <v-icon color="teal">mdi-email-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </div>
                            <div class="d-block sansation_title text-left white--text">Password</div>
                            <div class="d-block">
                                <v-text-field ref="passwd_field" 
                                    v-model="password" 
                                    solo 
                                    background-color="grey lighten-4"
                                    hint="Password is case-sensitive" 
                                    :append-icon="show_eye1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show_eye1 ? 'text' : 'password'" 
                                    @click:append="show_eye1 = !show_eye1"
                                    :rules="passRules" 
                                    required>
                                    <template v-slot:prepend-inner>
                                        <v-icon color="teal">mdi-lock-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </div>
                            <div class="text-left">
                                <v-btn 
                                    color="white" 
                                    class="pl-0 text-decoration-underline" 
                                    text
                                    @click="forgotDialog = true">
                                    Forgot Password?
                                </v-btn>
                            </div>

                            <v-dialog v-model="forgotDialog" width="40%">
                                <v-card>
                                    <v-card-title class="headline grey lighten-2" primary-title>Forgot Password Reset
                                    </v-card-title>

                                    <v-card-text class="mt-2">
                                        Provide us with your email address and we'll send you instructions on how to
                                        reset your password.
                                        <v-form v-model="forgot_valid" ref="forgot_form">
                                            <div class="flex-grow-1 text-center">
                                                <v-text-field 
                                                    v-model="reset_email" 
                                                    label="Email Address" 
                                                    color="primary"
                                                    :rules="emailRules" 
                                                    required>
                                                </v-text-field>
                                            </div>
                                            <div class="text-right">
                                                <v-btn class="mr-3" @click="resetClear">
                                                    clear
                                                </v-btn>
                                                <v-btn class="primary" dark @click.stop.prevent="resetPass">
                                                    Submit
                                                </v-btn>
                                            </div>
                                        </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>

                            <v-btn
                                class="sansation login_btn"
                                color="teal lighten-5"
                                style="height: 50px" 
                                dark 
                                @click.stop.prevent="logIn">
                                Login
                            </v-btn>
                            <div class="pt-15">
                                <v-btn plain color="white" class="text-decoration-underline" text
                                    href="https://www.successionresource.com/terms-of-service-privacy-policy"
                                    target="_blank">Terms of Service & Privacy Policy</v-btn>
                            </div>
                        </v-form>
                    </div>
                </v-col>

                <v-col cols="1 diagonale_box px-0">
                    <div class="line"></div>
                </v-col>
                <v-col id="signin_content" cols="6 copy_box pt-15 pl-0">
                    <v-row>
                        <div style="height: 94px;"></div>
                        <v-row>
                            <v-col cols="4" class="ml-n4">
                                <h1 class="sansation_super text-right">Marketplace</h1>
                                <div class="text-right">
                                    <a class="create_acct sansation pr-0 text-decoration-underline" color="primary"
                                        @click="credSwitch()">
                                        Join myCompass
                                    </a>
                                </div>
                                <v-dialog v-model="signup_fields" width="25%">
                                    <v-form ref="signup_form"
                                        v-model="signup_valid">
                                        
                                        <v-card class="pa-12">
                                            <v-row justify="center">
                                                <v-img :src="color_logo_img" max-width="180" class="d-block"
                                                    atl="Succession Resource Group"></v-img>
                                            </v-row>
                                            <h1 class="sansation_title text-center pb-10 pt-6">Create an Account</h1>
                                            <div class="d-block sansation">Full Name</div>
                                            <div class="d-block">
                                                <v-text-field ref="signup_name_field"
                                                    v-model="signup_fullname" 
                                                    solo
                                                    background-color="grey lighten-4" 
                                                    :rules="fullnameRules" 
                                                    required>
                                                </v-text-field>
                                            </div>

                                            <div class="d-block sansation">Company</div>
                                            <div class="d-block">
                                                <v-text-field ref="signup_company_field"
                                                    v-model.lazy="signup_company" 
                                                    solo
                                                    background-color="grey lighten-4" 
                                                    :rules="companyRules" 
                                                    required>
                                                </v-text-field>
                                            </div>

                                            <div class="d-block sansation">Email</div>
                                            <div class="d-block">
                                                <v-text-field ref="signup_email_field"
                                                    v-model.lazy="signup_email" 
                                                    solo
                                                    background-color="grey lighten-4" 
                                                    :rules="emailRules" 
                                                    required>
                                                </v-text-field>
                                            </div>

                                            <v-row justify="space-between">
                                                <v-btn 
                                                    class="primary ml-3"
                                                    :loading="signup_wait"
                                                    :disabled="signup_wait"
                                                    @click.stop.prevent="logIn">
                                                    Signup
                                                </v-btn>
                                                <v-btn 
                                                    class="primary--text mr-3" 
                                                    text 
                                                    @click="signup_fields = false">
                                                    Cancel
                                                </v-btn>
                                            </v-row>
                                        </v-card>
                                    </v-form>
                                </v-dialog>

                            </v-col>
                            <v-col cols="8">
                                <div class="pl-10 pr-12 pt-1">
                                    <p class="text-justify pr-4 avenir_book" style="font-size: 18px;">Our marketplace is
                                        exclusively
                                        for the financial services industry to allow buyers to find acquisition
                                        opportunities.
                                        This free tool offers real-time updates, information, and communication all in one
                                        easy to
                                        navigate place! <a href="https://www.successionresource.com/mycompass"
                                            target="_blank" class="marketing_link">
                                            Click here to learn more about myCompass Marketplace →</a>
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                        <br>
                        <v-row>
                            <v-col cols="4" class="ml-n4">
                                <h1 class="sansation_super text-right">Data Analytics & Benchmarking</h1>
                            </v-col>
                            <v-col cols="8">
                                <div class="pl-10 pr-12 pt-1">
                                    <p class="text-justify pr-4 avenir_book" style="font-size: 18px;">Our benchmarking
                                        dashboards provides you real-time information on valuation data, compensation
                                        information, and M&A statistics - giving you tools to learn more, hire an
                                        employee, buy or sell a practice, or engaging in a merger.</p>
                                </div>
                            </v-col>
                        </v-row>
                        <br>
                        <v-row>
                            <v-col cols="4" class="ml-n4">
                                <h1 class="sansation_super text-right">Project Hub</h1>
                            </v-col>
                            <v-col cols="8">
                                <div class="pl-10 pr-12 pt-1">
                                    <p class="text-justify pr-4 avenir_book" style="font-size: 18px;">Our Project Hub is a
                                        technology driven platform allowing you to access your project in-real time and
                                        share your data with different centers of influence to ensure everyone is on the
                                        same page.</p>
                                    <br>
                                    <p class="text-justify pr-6 avenir_book" style="font-size: 18px;">Bonus: myCompass is a
                                        secure platform and allows you to receive real-time status updates and
                                        communication about your project.</p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import Cookie from "js-cookie";
import { debounce } from 'debounce'
import appUrls from '../helpers/environment';

import logo_img from '../assets/SRGLogo_white_2022.svg';
import color_logo_img from '../assets/SRGLogo_full_color_2022.svg';
import backgroundUrl from '../assets/mycompass_loginbkg_mnt.jpg';
import getFingerPrint from '../lib/fingerprint'

export default {
    name: 'SignIn',

    data() {
        return {
            alertDialog: false,
            alertMessage: '',
            alertColor: 'error',
            alertDuration: 8000,
            forgotDialog: false,
            forgot_valid: false,
            login_valid: false,
            auth_valid: false,
            signup_valid: false,
            signup_fields: false,
            signup_wait: false,
            signIn_text: 'myCompass Sign In',
            cred_text: 'Create an account',
            submit_text: 'Login',
            username: window.location.hostname != ('mycompass.successionresource.com' || 'keen-hopper-ea9e22.netlify.app') ? 'john.doe@gmail.com' : '',
            password: window.location.hostname != ('mycompass.successionresource.com' || 'keen-hopper-ea9e22.netlify.app') ? '$coobysnax7652!' : '',
            signup_fullname: '',
            signup_company: '',
            signup_email: '',
            backgroundImage: { backgroundImage: `linear-gradient(to right top, rgba(0, 150, 166, 0.6), rgba(0, 150, 166, 0.9)), url(${backgroundUrl})` },
            logo_img: logo_img,
            color_logo_img: color_logo_img,
            backgroundUrl: backgroundUrl,
            reset_email: '',
            show_eye1: false,
            show_eye2: false,
            showAccessCodeForm: false,
            accessCode: '',
            fullnameRules: [
                (v) => !!v || 'Full Name is required'
            ],
            companyRules: [
                (v) => !!v || 'Company is required'
            ],
            passRules: [
                (v) => !!v || 'Password is required',
                (v) => v.length >= 8 || 'Password must be at least 8 charaters long.'
            ],
            emailRules: [
                (v) => !!v || 'Email is required',
                (v) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/.test(v) || 'Email must be in valid format'
            ],
            accessCodeRules: [
                (v) => !!v || 'Access Code is required',
                (v) => v.length === 6 || 'Access Code must be 6-characters',
            ]
        }
    },

    computed: {        
        // login_hotkey() {
        //     return { 'enter': this.logIn }
        // },
        // mfa_hotkey() {
        //     return { 'enter': this.mfa }
        // },
        // signup_hotkey() {
        //     return { 'enter': this.logIn }
        // }
        fingerprint() {
            const fingerprint = getFingerPrint();
            // console.log('fingerprint', fingerprint);
            return fingerprint;
        }
    },

    watch: {
        reset_email( mail ) {
            this.emailRules = [v => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,9}$/.test(v) || 'Email must be in valid format']
        },
        accessCode( val ) {
            if ( val.length == 6 ) {
                setTimeout(() => { this.$refs.mfa_field.blur() }, 700)
            }
        },
        password( val ) {
            if ( val != null ) {
                this.debouncedFields()
            }
        },
        // signup_email( val ) {
        //     if ( val != null && this.emailRules ) {
        //         this.debouncedFields()
        //     }
        // }
    
        // signup_wait () {
        //     this.signup_wait = !this.signup_wait
        // },
    },

    created() {
        document.title = 'SRG myCompass: Login'
    },

    mounted() {
        // console.log()
    },

    methods: {
        debouncedFields: debounce(function () {
			this.$refs.passwd_field.blur()
		}, 8000),

        credSwitch () {
            this.signup_fields = !this.signup_fields;
            this.cred_text = this.signup_fields ? 'Back to Login' : 'Create an account';
            this.submit_text = this.signup_fields ? 'Signup' : 'Login';
            this.signIn_text = this.signup_fields ? 'Create An Account' : 'MyCompass Sign In';
        },

        async logIn () {
            try {
                if ( this.$refs.login_form.validate() || this.$refs.signup_form.validate() )  {
                    this.signup_wait = true
                    const cred_url = this.signup_fields ? `${appUrls.api}/api/signup` : `${appUrls.api}/api/login/${this.$uuid.v4()}`
                    const field_data = this.signup_fields ? 
                        { 
                            "signup_fullname": this.signup_fullname.trim().replace("'", "''"), 
                            "signup_company" : this.signup_company.trim().replace("'", "''"),
                            "signup_email": this.signup_email.trim() 
                        } : 
                        { 
                            "username": this.username.trim(), 
                            "password": this.password.trim(), 
                            "fingerprint": this.fingerprint 
                        }

                    setTimeout( async () => {
                        const access_res = await axios.post(cred_url, {
                            headers: { "content-type": "application/json" },
                            data: field_data
                        })

                        if (access_res.data.outcome) {
                            this.signup_wait = false

                            // allow for psudo login
                            if (access_res.data.action == 'login') {
                                // Set secure cookies upon successful login
                                Cookie.set('token', access_res.data.sessionToken, { expires: 7, secure: true });
                                Cookie.set('is_client', access_res.data.landing == 'dashboard' ? true : false, { expires: 7, secure: true });
                                Cookie.set('has_profile', access_res.data.buyer_profile, { expires: 7, secure: true });
                                Cookie.set('name', access_res.data.user.first_name + ' ' + access_res.data.user.last_name, { expires: 7, secure: true });
                                Cookie.set('id', access_res.data.user.user_id, { expires: 7, secure: true });
                                Cookie.set('sugar', access_res.data.user.psudo, { expires: 7, secure: true });

                                this.$emit("authenticated", true);
                                this.$emit("isClient", access_res.data.landing == 'dashboard' ? true : false);

                                let landing_pg = '/login';
                                if (access_res.data.user.lockout === 2) {
                                    landing_pg = '/account';
                                } else if (this.$route.query.redirect != undefined) {
                                    landing_pg = this.$route.query.redirect;
                                } else {
                                    landing_pg = '/' + access_res.data.landing;
                                }
                                setTimeout(() => { this.$router.replace({ path: landing_pg }); }, 500)

                            } else {
                                if (access_res.data.action === 'mfa') {
                                    this.showAccessCodeForm = true;
                                    // focus cursor in the mfa code field
                                    setTimeout(() => {
                                        this.$refs.mfa_field.focus();
                                        this.$refs.mfa_field.initialValue = null;
                                    }, 50);
                                }
                                this.signup_fields = false;
                                this.$emit("authenticated", false);
                                this.alertMessage = access_res.data.message;
                                this.alertDuration = 10000;
                                this.alertColor = 'success';
                                this.alertDialog = true;
                            }
                        } else {
                            this.signup_wait = false
                            this.$emit("authenticated", false);
                            this.alertMessage = access_res.data.message;
                            this.alertDialog = true;
                            //this.close();
                        }
                    }, 3000)
                }
            } catch (err) {
                console.log(err)
                //this.alertMessage = error;
                //this.alertDialog = true;
            }
        },

        async mfa () {
            //do the stuff to verify mfa. send email and token
            try {
                if ( this.$refs.auth_form.validate() ) {
                    const cred_url = `${appUrls.api}/api/mfa`;
                    const field_data = {
                        username: this.username,
                        token: this.accessCode,
                        fingerprint: this.fingerprint,
                    }

                    const access_res = await axios.post(cred_url, {
                        headers: { "content-type": "application/json" },
                        data: field_data
                    })

                    if (access_res.data.outcome) {
                        if (access_res.data.action == 'login') {
                            // Set secure cookies upon successful login
                            // var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
                            Cookie.set('token', access_res.data.sessionToken, { expires: 7, secure: true });
                            Cookie.set('is_client', access_res.data.landing == 'dashboard' ? true : false, { expires: 7, secure: true });
                            Cookie.set('has_profile', access_res.data.buyer_profile, { expires: 7, secure: true });
                            Cookie.set('name', access_res.data.user.first_name + ' ' + access_res.data.user.last_name, { expires: 7, secure: true });
                            Cookie.set('id', access_res.data.user.user_id, { expires: 7, secure: true });
                            Cookie.set('sugar', access_res.data.user.psudo, { expires: 7, secure: true });

                            this.$emit("authenticated", true);
                            this.$emit("isClient", access_res.data.landing == 'dashboard' ? true : false);

                            let landing_pg = '/login';
                            if (access_res.data.user.lockout === 2) {
                                landing_pg = '/account';
                            } else if (this.$route.query.redirect != undefined) {
                                landing_pg = this.$route.query.redirect;
                            } else {
                                landing_pg = '/' + access_res.data.landing;
                            }
                            setTimeout(() => { this.$router.replace({ path: landing_pg }); }, 500)

                        }
                    } else {
                        this.alertMessage = access_res.data.message;
                        this.alertColor = 'error';
                        this.alertDialog = true;
                        if (access_res.data.action === "restart") {
                            this.accessCode = null;
                            this.showAccessCodeForm = false;
                        }
                    }

                }
            } catch (error) {
                console.log(error)
            }
        },

        async resetPass () {
            try {
                if ( this.$refs.forgot_form.validate() ) {
                    const resetpw = await axios.post(`${appUrls.api}/api/resetpw`, {
                        headers: { "content-type": "application/json" },
                        email_address: this.reset_email.trim(),
                        source: 'client'
                    })
                    
                    if ( resetpw.data.outcome ) {
                        // console.log(resetpw.data)
                        this.$emit("authenticated", false);
                        this.alertMessage = resetpw.data.message;
                        this.alertDuration = 10000;
                        this.alertColor = 'success';
                        this.alertDialog = true;
                        this.forgotDialog = false;
                    } else {
                        this.$emit("authenticated", false);
                        this.alertMessage = resetpw.data.message;
                        this.alertDuration = 10000;
                        this.alertColor = 'error';
                        this.alertDialog = true;
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },

        resetClear() {
            this.$refs.forgot_form.reset()
        },

        close() {
            setTimeout(() => {
                this.alertDialog = false
            }, 5000)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/* background-image: linear-gradient(to right top, rgba(0, 150, 166, 0.6), rgba(0, 150, 166, 0.9)), url(/static/img/mycompass_loginbkg_mnt.8664dc5.jpg); */
>>> .v-messages__message {
  color: white !important;
}
#signin_wrapper {
    width: 100%;
    height: 100%;

    background-position: top left;
}
#signin_content {
    position: relative;
    z-index: 1;
}
#login {
    min-width: 100%;
    max-width: 100%;
    margin: 2% auto;
    padding: 16%;
    text-align: center;
    font-size: .8rem;
    border-radius: 8px;
}
.login_btn {
    padding: 4px !important;
    min-width: 100% !important;
    max-width: 100% !important;
    color: #333333 !important;
    font-size: 1.3em !important;
}
.mnt_image {
    background-position: top left;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
}
.return_link {
    font-size: 1.25rem;
    text-decoration: none;
    /* mdi-keyboard-backspace */
}
.marketing_link {
    text-decoration: none;
}
.signin_title {
    /* color: #37383C; */
    font-weight: 600;
    font-size: 1.6rem !important;
    letter-spacing: 0.05rem;
}
.copy_box {
    background-color: #FAFBFC;
    min-height: 100%;
}
.diagonale_box {
    border-top: 1px solid white;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    background:
        linear-gradient(to top right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - 0.8px),
            #FAFBFC 50%,
            #FAFBFC calc(50% + 0.8px),
            #FAFBFC 100%);
}
.create_acct {
    height: 36px;
    min-width: 64px;
    color: #0096a6 !important;
}
.mycompass_title {
    font-family: 'Sansation';
    font-size: 32px !important;
}
.top_level {
    z-index: 301 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue